<template>
	<div class="schedule-video-call">
    <div class="modal fade" id="modalEscheduleVideoCall" tabindex="-1" role="dialog" aria-labelledby="modalEscheduleVideoCallLabel" aria-hidden="true">
      <div class="modal-dialog modal-edit-contract" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalEscheduleVideoCallLabel">Enviar link de entrevista a candidato</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
						<div :class="typeMessage" role="alert" id="message-update" v-if="message != ''">
							{{message}}
						</div>    							
          </div>
          <div class="modal-body">            
						<div class="form-group">
							<div class="row">
								<label class="col-md-12 control-label">
									Fecha y hora de realización de la visita:
								</label>
							</div>
							<div class="row">
								<div class="col-md-12">
									<input type="datetime-local" name="visit_date_time" id="visit_date_time" value="" class="form-control" v-model="visit_date_time">                
									<span class="help-block"></span>
								</div>
							</div>
						</div>
						<div class="form-group">
							<div class="row">
								<label class="col-md-12 control-label">
									Tiempo de caducidad en horas:
								</label>
							</div>
						</div>
						<div class="form-group form-actions">
							<div class="col-md-12 button-send">
								<input type="submit" name="commit" value="envíar" class="btn btn-primary btn-lg btn-block" @click.prevent="schedule()">
							</div>
						</div>												
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
          </div>
        </div>
      </div>
    </div>		
	</div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios';
export default {
	name: 'ModalScheduleVideoCall',
	props: ['current_user', 'assignment_id'],
	methods: {
		liActive(page){
			var classLi = ""
			if(page == this.paginate.current_page){
				classLi = "active"
			}
			return classLi
		},
		schedule(){
			console.log("**schedule**")
			this.defaultValuesAxios()
			axios.get(`/workers/send_link_interview?assignment_id=${this.assignment_id}&visit_date_time=${this.visit_date_time}`).then(res=>{
				if(res.status == 200){
					this.showMessage(res.data.message, 'alert-success')
				}else{
					this.showMessage(res.data.message, 'alert-warning')
				}
			}, (err) => {
				this.showMessage(err, 'alert-danger')
			})
		},
		showMessage(message, typeMessage){
			this.message = message
			this.typeMessage = typeMessage
			setTimeout(() => this.message = '', 3000)
		},				
		defaultValuesAxios(){
			var token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
			axios.defaults.headers['x-csrf-token'] = token
			axios.defaults.headers.common['Accept'] = 'application/json';
			axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
		}
	},
	data() {
		return {
			message: '',
			typeMessage: '',
			visit_date_time: ''
		}
	},
	watch: {

	},
	created () {

	},
	components: {

	},
	filters: {

	}
}
</script>
<style scoped>

</style>
